import { Suspense, useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Loader } from '@/ui'
import { OfflineBanner } from '@/ui/OfflineBanner'
import Sidebar from './Sidebar'
import MobileHeader from './MobileHeader'
import BottomNav from './BottomNav'
import { useSidebar } from '@/contexts/SidebarContext'
import { MobileHeaderProvider } from '@/contexts/MobileHeaderContext'

export default function Layout() {
  const { sidebarOpen, setSidebarOpen, sidebarCollapsed, setSidebarCollapsed } = useSidebar()
  const location = useLocation()
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (sidebarOpen) setSidebarOpen(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <MobileHeaderProvider>
      <div className="flex flex-col h-[100dvh] overflow-hidden bg-[var(--surface-page)]">
        <OfflineBanner />

        <Sidebar
          collapsed={sidebarCollapsed}
          onCollapsedChange={setSidebarCollapsed}
        />

        <div ref={scrollRef} className={`mobile-scroll flex-1 min-h-0 flex flex-col transition-all duration-300 ${sidebarCollapsed ? 'md:pl-20' : 'md:pl-60'}`}>
          <MobileHeader />

          <main className="flex-1 min-h-0 md:h-full md:overflow-hidden">
            <Suspense fallback={<div className="flex items-center justify-center py-20"><Loader /></div>}>
              <Outlet />
            </Suspense>
            {/* Clears fixed BottomNav (h-14) on mobile; invisible on md+ due to overflow-hidden on main */}
            <div className="md:hidden h-14 very-short:h-11 shrink-0" aria-hidden="true" />
          </main>
        </div>

        <BottomNav />
      </div>
    </MobileHeaderProvider>
  )
}
